import React from 'react';

import Icon from 'Core/Components/Icon';

import { addNewPage } from 'RLX/State/Content/ContentActions';
import {
  expandSidebarPagesList as expand,
  collapseSidebarPagesList as collapse
} from 'RLX/State/Ui/Sidebar/SidebarActions';

function PagesMenu ({ siteData, ui } = {}) {
  const { pages } = siteData;
  const collapsed = ui.sidebar.pagesListCollapsed;

  const pageLinks = collapsed ? [] : pages.map(page => ({
    text: page.name && page.name.length
      ? page.name
      : <i>@{page.id} <span style={{opacity:0.33}}>(untitled)</span></i>,
    url: '/RLX/dash/pages/' + page.id,
    icon: 'chevron-right'
  }));

  return [
    {
      text: <span>PAGES &nbsp;<small>({pages.length})</small></span>,
      className: 'heading' + (collapsed ? ' collapsed' : ''),
      onClick: collapsed ? expand : collapse,
      icon: collapsed ? 'caret-left' : 'caret-down'
    },
    ...pageLinks,
    {
      text: (
        <button onClick={addNewPage}>
          Add a Page
          <Icon fa="plus right" />
        </button>
      )
    }
  ];
};

export default PagesMenu;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Config/Menus/PagesMenu.jsx